import React from 'react'
import {
  SearchRatables,
  SearchRatableItemProps
} from '../Ratables/SearchRatables'

// TODO: Move these types up a level so that they can be shared between related components
export type DataViewRatablesAnalyst = {
  firstName: string
  lastName: string
  role: string
  sequenceNumber: number
  type: string
}

export type DataViewRatablesMarketingItem = {
  name: string
  slug: string
}

export type DataViewRatablesMarketing = {
  analysts: DataViewRatablesAnalyst[] | null
  countries: DataViewRatablesMarketingItem[]
  languages: DataViewRatablesMarketingItem[]
  sectors: DataViewRatablesMarketingItem[]
}

export type DataViewRatablesRenderLinkProps = Partial<SearchRatableItemProps>

export type DataViewRatablesProps = {
  items: SearchRatableItemProps[]
}

export const DataViewRatables = ({ items }: DataViewRatablesProps) => (
  <div className="column__main">
    <SearchRatables items={items} defaultPageSize={25} printView={false} />
  </div>
)
